import { EditorActions, EditorState, NodeTree, useEditorReturnType } from '@candulabs/craft';

import { BuiltInComponents } from 'craft/constants';
import { InsertNodeTreesAtIndex } from 'craft/hooks';

export const flowInsertNodeTreesAtIndex: InsertNodeTreesAtIndex = (
  nodeTrees: NodeTree[],
  parentNodeId: string,
  insertAtIndex: number,
  editor: useEditorReturnType,
  insert: (nodeTrees: NodeTree[], parentNodeId: string, insertAtIndex: number) => void,
) => {
  const { query } = editor;

  const isFlowStepNode = nodeTrees.every(
    ({ rootNodeId, nodes }: NodeTree) => nodes[rootNodeId].data.name === BuiltInComponents.FlowStep,
  );

  if (isFlowStepNode) {
    editor.actions.produceState((_: EditorState, actionsWithoutHistory: EditorActions) => {
      actionsWithoutHistory.resetEvents();
      const newTreeIds = nodeTrees.map((tree, i) => {
        const newTree: NodeTree = tree;
        actionsWithoutHistory.addNodeTree(newTree, parentNodeId, insertAtIndex + i);
        return newTree.rootNodeId;
      });

      actionsWithoutHistory.selectNode(newTreeIds);
    });
    return;
  }

  const visibleFlowStepNodeId = query
    .node(parentNodeId)
    ?.get()
    ?.dom?.firstElementChild?.getAttribute('data-nid');

  if (!visibleFlowStepNodeId) {
    return;
  }

  const lastIndexOfFlowStepNodes = query.node(visibleFlowStepNodeId).descendants().length;

  insert(nodeTrees, visibleFlowStepNodeId, lastIndexOfFlowStepNodes);
};
